module.exports = __webpack_public_path__ + "img/mission.a7a90df0.png";